import {ApiObject} from "./api"
import {ApiObjectFields, EOFields, 
  ItemCode, WarehouseCode,
} from "./types"
import {ItemCodeTypeMap, WarehouseCodeTypeMap,
  BooleanTypeMap, StringTypeMap, NumberTypeMap} from "./generaltypemaps"

export const ItemWarehouseFields = {
  itemCode: ItemCodeTypeMap,
  itemDescription: StringTypeMap,
  warehouseCode: WarehouseCodeTypeMap,
  currentStock: NumberTypeMap,
  itemIsStockItem: BooleanTypeMap,
  plannedStockIn: NumberTypeMap,
  plannedStockOut: NumberTypeMap,
  planningDetailsUrl: StringTypeMap,
  safetyStock: NumberTypeMap,
}

export class ItemWarehouse extends ApiObject
    implements ApiObjectFields<typeof ItemWarehouseFields> {
  readonly itemCode: ItemCode
  readonly itemDescription: string
  readonly warehouseCode: WarehouseCode
  readonly currentStock: number
  readonly itemIsStockItem: boolean
  readonly plannedStockIn: number
  readonly plannedStockOut: number
  readonly planningDetailsUrl: string
  readonly safetyStock: number

  static DEFAULT_WARNING_STOCK_LEVEL = 100 as const
  static DEFAULT_INFO_STOCK_LEVEL = 500 as const

  constructor(props: EOFields<typeof ItemWarehouse>) {
    super({})
    this.itemCode =
      ItemWarehouse.FIELDS.itemCode.fromEO(props.ItemCode)
    this.itemDescription =
      ItemWarehouse.FIELDS.itemDescription.fromEO(
        props.ItemDescription)
    this.warehouseCode = ItemWarehouse.FIELDS.warehouseCode.fromEO(
      props.WarehouseCode)
    this.currentStock = ItemWarehouse.FIELDS.currentStock.fromEO(props.CurrentStock)
    this.itemIsStockItem =
      ItemWarehouse.FIELDS.itemIsStockItem.fromEO(props.ItemIsStockItem)
    this.plannedStockIn = ItemWarehouse.FIELDS.plannedStockIn.fromEO(
      props.PlannedStockIn)
    this.plannedStockOut = ItemWarehouse.FIELDS.plannedStockOut.fromEO(
      props.PlannedStockOut)
    this.planningDetailsUrl = ItemWarehouse.FIELDS.planningDetailsUrl.fromEO(
      props.PlanningDetailsUrl)
    this.safetyStock = ItemWarehouse.FIELDS.safetyStock.fromEO(props.SafetyStock)
  }

  static get FIELDS(): typeof ItemWarehouseFields {
    return ItemWarehouseFields
  }

  static get URL(): string {
    return "inventory/ItemWarehouses"
  }

}

